import { CloseOutlined } from "@ant-design/icons"
import { Image, Modal, Space } from "antd"
import {Attachment} from "pages/common"

export const PreviewModal = ({ open, onCancel, src, fileName=undefined }) => {
  return (
      <Modal
        open={open}
        width={'auto'}
        footer={fileName &&<Attachment icon={'download'} label={fileName} url={src} /> }
        centered={true}
        closeIcon={<CloseOutlined style={{ color: '#ffffff', fontSize: '25px' }} />}
        onOk={onCancel}
        onCancel={onCancel}
        styles={{
          content: {backgroundColor: 'rgba(1,1,1,0.7)', boxShadow: 'unset'},
          body: {backgroundColor: 'unset', padding: '2rem'},
        }}
      >
        <Space direction="vertical" align="center">
          <Image preview={false} src={src} />
        </Space>
      </Modal>
  )
}